import React from 'react'
import Rating from '../../../../../Components/Rating/Rating'
import { Subscribe } from 'unstated'
import LeaveReviewStore from '../Store/LeaveReviewStore'
import ReactQuill from 'react-quill'

const CourseInfo = () => {
  return (
    <Subscribe to={[LeaveReviewStore]}>
      {({
        state: {
          courseInfo: { name, cover, teacherName, rating, description },
        },
      }) => (
        <div className='courseInfo'>
          <div className='headInfo'>
            <div
              className='cover'
              style={{
                background: `url(${cover}) center center /cover no-repeat`,
              }}
            />
            <div className='info'>
              <h2>{name}</h2>
              <p className='teacherName'>{teacherName}</p>
              <Rating value={rating} showValue />
            </div>
          </div>
          <p className='description'>
            <ReactQuill value={description} readOnly theme={null} />
          </p>
        </div>
      )}
    </Subscribe>
  )
}

export default CourseInfo
